module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("PART I"), _c('br'), _vm._v("FROM JERUSALEM TO TIMBUKTU")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_vm._v("1 Faith Is on the Rise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-001"
    }
  }, [_vm._v("SECULAR ASSUMPTIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-002"
    }
  }, [_vm._v("A SURPRISING SURGE")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-003"
    }
  }, [_vm._v("THE DRIVERS OF GLOBAL FAITH")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p2"
    }
  }, [_vm._v("PART II"), _c('br'), _vm._v("DRIVERS GROWING AND SHAPING THE CHURCH")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p2chap1"
    }
  }, [_vm._v("2 The Age of the Spirit")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p2chap1#niv1-004"
    }
  }, [_vm._v("HOW WAS THE SPIRIT UNDERSTOOD?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p2chap1#niv1-005"
    }
  }, [_vm._v("WHAT TRIGGERED THE REVOLUTION?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p2chap1#niv1-006"
    }
  }, [_vm._v("THREE FACTORS AT PLAY")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p2chap1#niv1-007"
    }
  }, [_vm._v("OUT OF STEP")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p2chap1#niv1-008"
    }
  }, [_vm._v("WHAT DID THE PENTECOSTAL MOVEMENT PRODUCE?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p2chap1#niv1-009"
    }
  }, [_vm._v("WHERE HAS THE MOVEMENT BEEN TAKEN UP?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 The Power of Bible Translation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2#niv1-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EXPANDING THE GOSPEL FOOTPRINT")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2#niv1-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A FAITH TRANSLATED FOR ALL")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2#niv1-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT BIBLE TRANSLATION ACCOMPLISHES")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2#niv1-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE BIBLE’S INHERENT POWER")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2#niv1-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GETTING THE BIBLE INTO THE LANGUAGE OF THE PEOPLE")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2#niv1-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLACES OF UPSURGE")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Revolution of the Indigenous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDIGENOUS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3#niv1-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE POWER OF MULTIPLICATION")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3#niv1-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MISSIONS IN CONTEXT")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3#niv1-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE RENEWALIST PUSH")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Re-engaging the Public Square")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4#niv1-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT WE MEAN BY THE PUBLIC SQUARE")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4#niv1-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOW WE GOT HERE")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4#niv1-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FROM EXCLUSION TO ENGAGEMENT")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4#niv1-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A GLOBAL TOUR")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Power of the Whole Gospel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5#niv1-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE NAZARENE MANIFESTO")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOW WHOLENESS WAS LOST")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A TURNAROUND: THE EMBRACE OF WHOLENESS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FACING SYSTEMIC ISSUES")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III"), _c('br'), _vm._v("JESUS GOES GLOBAL")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Wholeness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRAYER MOVEMENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WOMEN IN MINISTRY")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRAISE AND WORSHIP")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A HUMAN TIDAL WAVE: REFUGEES AND MIGRATION")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PERSECUTION")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Global Reflections")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("From Jerusalem to Timbuktu")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About The Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0